import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import queryString from 'query-string';


import React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { dev_baseUrl } from 'utils/var';



const ConfirmEmail = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const confirmEmail = async () => {
      const { userId, token } = queryString.parse(location.search);
      const encodedToken = encodeURIComponent(token);

      try {
        const response = await fetch(`${dev_baseUrl}/account/confirmemail?userId=${userId}&token=${encodedToken}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        });

        const data = await response.json();

        if (response.ok && !data.isError) {
          navigate('/login', { state: { message: (data ? data.result : 'Registration successful, please login to continue') } });
        } else {
          console.error('Error:', data.message);
          navigate('/login', { state: { message: 'Registration failed. Please try again.' } });
        }
      } catch (error) {
        console.error('Error:', error);
        navigate('/login', { state: { message: 'An error occurred. Please try again later.' } });
      }
    };

    confirmEmail();
  }, [location.search, navigate]);

  return (
    <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    minHeight="100vh"
  >
    <CircularProgress />
    <Typography variant="body1" mt={2}>
      Confirming your email...
    </Typography>
  </Box>
  );
};

export default ConfirmEmail;
